import store from '../store';
import vueCookie from 'vue-cookie';

export const requestUrl = process.env.API_URL;
export var requestHeaders = new Headers({
  'accept': 'application/json, */*',
  'content-type': 'application/json'
});

let authToken = null;

if (store !== undefined && store.getters['getAuthToken'] !== null)
{
  authToken = store.getters['getAuthToken'];
}
else if (vueCookie.get('authToken') !== undefined)
{
  authToken = vueCookie.get('authToken');
}

requestHeaders.append('authorization', authToken);

export var requestOptions = {
  mode: 'cors',
  method: 'post',
  referrerPolicy: 'origin',
};


// WEBPACK FOOTER //
// ./src/store/graphQLClient.js